import { Icon, Text, Tooltip } from '@dixa/lib-shared-habla';

type ConditionMatchedIndicatorProps = {
  /**
   * Human-readable labels for the fields referenced by the widget's render
   * conditions.
   */
  fieldLabels: readonly string[];
  /**
   * Whether the widget's conditions evaluated to true for the current
   * conversation.
   */
  isMatched: boolean;
};

export const ConditionMatchedIndicator = ({
  fieldLabels,
  isMatched,
}: ConditionMatchedIndicatorProps): JSX.Element | null => {
  if (fieldLabels.length === 0) {
    return null;
  }

  const verb = isMatched ? 'matched' : 'not matched';
  const tooltipContent = (
    <Text.Paragraph variant="4" color="neutral.000">
      Condition {verb} on: {fieldLabels.join(', ')}
    </Text.Paragraph>
  );

  return (
    <Tooltip content={tooltipContent}>
      <Icon
        name="filter"
        size={16}
        color={isMatched ? 'green.500' : 'neutral.500'}
      />
    </Tooltip>
  );
};
